export default function openDocument(blob: Blob, fileName: string, isDownload = false, shouldPrint = false): void {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);

    link.setAttribute('rel', 'noopener noreferrer');
    link.href = url;
    if (isDownload) {
        link.download = fileName;
    } else {
        link.setAttribute('target', '_blank');
    }

    document.body.appendChild(link);

    if (shouldPrint) {
        // For print, we need to handle the opened window
        const printWindow = window.open(url, '_blank');
        if (printWindow) {
            printWindow.addEventListener('load', () => {
                printWindow.print();
                // Optionally close after printing
                printWindow.addEventListener('afterprint', () => {
                    printWindow.close();
                });
            });
        }
    } else {
        const ev = new MouseEvent('click');
        link.dispatchEvent(ev);
    }

    document.body.removeChild(link);

    // don't revoke the url if we are printing or previewing in a new tab
    if (!shouldPrint && isDownload) {
        // Deferred, not synchronous: the click above only *starts* the save. Revoking on the same
        // tick can pull the object URL out from under a large file mid-write, truncating it.
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }
}
